import React from "react";
import { Wrapper } from "../HOC";
import { FaRegClock } from "react-icons/fa";
import { MdPhoneAndroid, MdLocationPin } from "react-icons/md";
import Image01 from "../assets/svg/location.svg";
import Image02 from "../assets/svg/liveChat.svg";

const Contact = () => {
  return (
    <Wrapper>
      <div className="flex justify-between w-full pb-5">
        <div className="w-[45%]">
          <p className="text-2xl font-bold pb-4">Contact Us</p>
          <div className="flex items-center pl-8 text-[#000] border-2 w-[70%] py-6 rounded-lg mb-5">
            <FaRegClock className="text-6xl" />
            <div className="pl-3">
              <p className="text-2xl font-bold pb-1">Work Hours</p>
              <p className="text-sm text-black">
                Monday - Friday: 09.00 - 23.00
              </p>
              <p className="text-sm text-black">Sunday: 09.00 - 16.00</p>
            </div>
          </div>
          <div className="flex items-center pl-8 text-[#000] border-2 w-[70%] py-6 rounded-lg mb-5">
            <MdPhoneAndroid className="text-6xl" />
            <div className="pl-3">
              <p className="text-2xl font-bold pb-1">Phone</p>
              <p className="text-sm text-black">(+1) 123 123 123</p>
              <p className="text-sm text-black">info@exampel.com</p>
            </div>
          </div>
          <div className="flex items-center pl-8 text-[#000] border-2 w-[70%] py-6 rounded-lg mb-5">
            <MdLocationPin className="text-6xl" />
            <div className="pl-3">
              <p className="text-2xl font-bold pb-1">Address</p>
              <p className="text-sm text-black">123 Ave, Lorem City</p>
              <p className="text-sm text-black">site Country, The World</p>
            </div>
          </div>
          <img src={Image02} alt="" />
        </div>

        <div className="w-[45%]">
          <p className="text-2xl font-bold pb-4">We are Located Here</p>
          <img src={Image01} alt="" />
        </div>
      </div>
    </Wrapper>
  );
};

export default Contact;
